import React from "react"
export default function HK() {
  return (
    <>
      <svg
        width="32"
        height="24"
        viewBox="0 0 32 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_5553_9701)">
          <rect width="32" height="24" rx="2" fill="white" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0V24H32V0H0Z"
            fill="#EA1A1A"
          />
          <mask
            id="mask0_5553_9701"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="32"
            height="24"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 0V24H32V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_5553_9701)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.8692 11.574C15.8692 11.574 10.0795 6.41072 16.9884 3.40234C16.9884 3.40234 18.9976 5.61896 17.4903 8.10742C16.9958 8.92359 16.5787 9.5064 16.2653 9.94439C15.6231 10.8417 15.416 11.1311 15.8692 11.574ZM7.32446 7.86673C6.92683 15.3916 14.1338 12.5213 14.1338 12.5213C13.5353 12.7286 13.369 12.4139 12.8536 11.4387L12.8536 11.4387C12.6019 10.9625 12.267 10.3289 11.7578 9.52153C10.2059 7.06057 7.32446 7.86673 7.32446 7.86673ZM18.2379 11.8263C18.2379 11.8263 25.6698 14.0512 20.6857 19.7028C20.6857 19.7028 17.9264 18.5456 18.2379 15.6532C18.3401 14.7048 18.4709 14.0003 18.5693 13.4709C18.7709 12.3857 18.8359 12.0356 18.2379 11.8263ZM16.2845 13.5609C16.2845 13.5609 17.6168 21.2032 10.3334 19.2719C10.3334 19.2719 10.1351 16.2865 12.8616 15.272C13.7559 14.9392 14.4446 14.7413 14.9622 14.5925L14.9622 14.5925L14.9623 14.5925L14.9623 14.5925C16.0227 14.2877 16.3647 14.1894 16.2845 13.5609ZM25.4784 10.2745C20.9229 4.27234 17.2735 11.1177 17.2735 11.1177C17.5968 10.5729 17.9269 10.7057 18.95 11.1174C19.4497 11.3185 20.1148 11.5862 21.0252 11.8739C23.7991 12.7506 25.4784 10.2745 25.4784 10.2745Z"
              fill="white"
            />
            <path
              d="M9.95117 10.3424L10.3732 10.0742C11.2995 11.5321 12.5018 12.2495 14.0021 12.2495V12.7495C12.3236 12.7495 10.9659 11.9394 9.95117 10.3424Z"
              fill="#EA1A1A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M21.75 10.75C22.1642 10.75 22.5 10.4142 22.5 10C22.5 9.58579 22.1642 9.25 21.75 9.25C21.3358 9.25 21 9.58579 21 10C21 10.4142 21.3358 10.75 21.75 10.75Z"
              fill="#EA1A1A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.959 15.7266C20.3732 15.7266 20.709 15.3908 20.709 14.9766C20.709 14.5623 20.3732 14.2266 19.959 14.2266C19.5448 14.2266 19.209 14.5623 19.209 14.9766C19.209 15.3908 19.5448 15.7266 19.959 15.7266Z"
              fill="#EA1A1A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.959 17.7266C14.3732 17.7266 14.709 17.3908 14.709 16.9766C14.709 16.5623 14.3732 16.2266 13.959 16.2266C13.5448 16.2266 13.209 16.5623 13.209 16.9766C13.209 17.3908 13.5448 17.7266 13.959 17.7266Z"
              fill="#EA1A1A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.95898 10.7266C10.3732 10.7266 10.709 10.3908 10.709 9.97656C10.709 9.56235 10.3732 9.22656 9.95898 9.22656C9.54477 9.22656 9.20898 9.56235 9.20898 9.97656C9.20898 10.3908 9.54477 10.7266 9.95898 10.7266Z"
              fill="#EA1A1A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.959 7.72656C16.3732 7.72656 16.709 7.39078 16.709 6.97656C16.709 6.56235 16.3732 6.22656 15.959 6.22656C15.5448 6.22656 15.209 6.56235 15.209 6.97656C15.209 7.39078 15.5448 7.72656 15.959 7.72656Z"
              fill="#EA1A1A"
            />
            <path
              d="M15.635 7.05157L16.0746 7.28984C15.242 8.82583 15.1832 10.2426 15.8883 11.5686L15.4468 11.8033C14.6595 10.3227 14.7256 8.72923 15.635 7.05157Z"
              fill="#EA1A1A"
            />
            <path
              d="M22.0143 9.68702L21.9394 10.1814C19.9836 9.88487 18.5196 10.2975 17.5172 11.4108L17.1456 11.0762C18.2702 9.82723 19.9032 9.36698 22.0143 9.68702Z"
              fill="#EA1A1A"
            />
            <path
              d="M20.3511 15.366L19.8609 15.4647C19.4706 13.5254 18.5822 12.2909 17.1932 11.7297L17.3805 11.2661C18.9388 11.8957 19.9298 13.2728 20.3511 15.366Z"
              fill="#EA1A1A"
            />
            <path
              d="M13.9058 17.1502L13.6454 16.7234C15.3342 15.6933 16.1905 14.4362 16.2428 12.939L16.7425 12.9565C16.6838 14.6361 15.7287 16.0384 13.9058 17.1502Z"
              fill="#EA1A1A"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_5553_9701">
            <rect width="32" height="24" rx="2" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  )
}
